import {AboutBlockComponent} from '../../../js/custom-components/about/about-block-component';
import {ProjectsBlockComponent} from '../../../js/custom-components/projects/projects-block-component';

class MainElement extends React.Component{		
	render(){	
		return (
					<main className="main-element">
						<div className="container main-container">
							<ProjectsBlockComponent />
							<AboutBlockComponent />
						</div>
				</main>
		);
	}
}

export { MainElement };











// WEBPACK FOOTER //
// in/js/custom-components/general/main-element-component.js